(function () {
	'use strict';

	// ── Core: elxr global ──────────────────────────────────────────────────────

	function elixirLog(component, message, level) {
		level = level || 'info';
		message = typeof message === 'object' ? JSON.stringify(message, null, 4) : message;
		console[level](
			'%c💧 Elixir%c@v' + window.elxr['version'] + '%c • %c[' + component + '::' + level.toUpperCase() + '] %c' + message,
			'color: #66C3ED; font-weight: bold;',
			'color: #AAAAAA;',
			'color: inherit;',
			'color: lightgreen;',
			'color: inherit;',
		);
	}

	window.elxr = window.elxr || {};
	window.elxr['version'] = '1.7.0-dev-v2-combined';
	window.elxr['log'] = elixirLog;

	window.elxr.log('CoreElixir', 'Ready!');

	// ── Pricing ────────────────────────────────────────────────────────────────

	function _getDisplayPrice(opts) {
		var price = Math.round(Number(opts.price) || 0);
		var quantity = Math.max(1, parseInt(opts.quantity, 10) || 1);
		var multiplyByQuantity = opts.multiplyByQuantity !== false;
		var applySubscriptionDiscount = opts.applySubscriptionDiscount !== false;
		var compareAtPrice = opts.compareAtPrice != null ? Math.round(Number(opts.compareAtPrice) || 0) : 0;

		var totalPrice = multiplyByQuantity ? price * quantity : price;
		var totalCompare = multiplyByQuantity ? compareAtPrice * quantity : compareAtPrice;

		if (applySubscriptionDiscount && window.subscriptionContext) {
			var ctx = window.subscriptionContext;
			var perUnitBase = Math.round(totalPrice / quantity);
			var discountType = ctx.discountType;
			var discountValue = parseFloat(ctx.discountValue) || 0;
			var finalPricePerUnit = ctx.finalPrice != null && ctx.finalPrice !== '' ? parseFloat(ctx.finalPrice) : null;
			var requestVariantId = opts.variantId != null && opts.variantId !== '' ? String(opts.variantId) : null;
			var contextVariantId = ctx.variantId != null && ctx.variantId !== '' ? String(ctx.variantId) : null;
			var isOtherVariant = requestVariantId && contextVariantId && requestVariantId !== contextVariantId;

			var ctxOriginal = parseFloat(ctx.originalPrice) || 0;
			var isCustomTotal = !isOtherVariant && ctxOriginal > 0 && finalPricePerUnit !== null &&
				!isNaN(finalPricePerUnit) && Math.abs(perUnitBase - ctxOriginal) > 1;

			var perUnitAfterDiscount;
			if (isCustomTotal) {
				// Custom tier totals (BOGO, fixed bundle amounts) keep their price and take the plan's discount ratio.
				return {
					price: Math.max(0, Math.round(totalPrice * (finalPricePerUnit / ctxOriginal))),
					compareAtPrice: totalCompare,
				};
			} else if (isOtherVariant) {
				if (discountType === 'percentage') {
					perUnitAfterDiscount = Math.max(0, Math.round(perUnitBase * (1 - discountValue / 100)));
				} else if (discountType === 'fixed_amount') {
					perUnitAfterDiscount = Math.max(0, Math.round(perUnitBase - discountValue));
				} else {
					perUnitAfterDiscount = perUnitBase;
				}
			} else {
				if (finalPricePerUnit !== null && !isNaN(finalPricePerUnit)) {
					perUnitAfterDiscount = Math.max(0, Math.round(finalPricePerUnit));
				} else if (discountType === 'percentage') {
					perUnitAfterDiscount = Math.max(0, Math.round(perUnitBase * (1 - discountValue / 100)));
				} else if (discountType === 'fixed_amount') {
					perUnitAfterDiscount = Math.max(0, Math.round(perUnitBase - discountValue));
				} else if (discountType === 'price') {
					var perUnitCents = (finalPricePerUnit != null && !isNaN(finalPricePerUnit) ? finalPricePerUnit : discountValue);
					perUnitAfterDiscount = Math.max(0, Math.round(perUnitCents));
				} else {
					perUnitAfterDiscount = perUnitBase;
				}
			}
			totalPrice = perUnitAfterDiscount * quantity;
		}

		return { price: totalPrice, compareAtPrice: totalCompare };
	}

	function _setSubscriptionContext(planId, variant, plan) {
		if (planId == null || planId === '' || !variant) {
			if (window.subscriptionContext) {
				delete window.subscriptionContext;
			}
			document.dispatchEvent(new CustomEvent('subscriptionContext:updated', {
				detail: { subscriptionContext: null },
			}));
			return;
		}

		var originalPrice = 0;
		if (typeof variant.price === 'number') {
			originalPrice = variant.price;
		} else if (typeof variant.price === 'string') {
			originalPrice = parseInt(variant.price, 10) || 0;
		} else if (variant.currentPrice != null) {
			originalPrice = typeof variant.currentPrice === 'number' ? variant.currentPrice : parseInt(variant.currentPrice, 10) || 0;
		}

		var finalPrice = originalPrice;
		var discountType = null;
		var discountValue = null;

		if (plan && plan.priceAdjustments && plan.priceAdjustments.length > 0) {
			var adjustment = plan.priceAdjustments[0];
			var adjustmentValue = parseFloat(adjustment.value);
			discountType = adjustment.valueType;
			discountValue = adjustmentValue;

			switch (adjustment.valueType) {
				case 'percentage':
					finalPrice = originalPrice * (1 - adjustmentValue / 100);
					break;
				case 'fixed_amount':
					finalPrice = originalPrice - adjustmentValue;
					break;
				case 'price':
					finalPrice = adjustmentValue;
					break;
				default:
					finalPrice = originalPrice;
			}
		}

		var variantId = variant && (variant.id != null) ? String(variant.id) : null;
		window.subscriptionContext = {
			variantId: variantId,
			originalPrice: Math.round(originalPrice),
			priceWithDiscount: Math.max(0, Math.round(finalPrice)),
			discountType: discountType,
			discountValue: discountValue,
			finalPrice: Math.max(0, Math.round(finalPrice)),
			sellingPlanId: String(planId),
		};

		document.dispatchEvent(new CustomEvent('subscriptionContext:updated', {
			detail: { subscriptionContext: window.subscriptionContext },
		}));
	}

	function _formatMoney(cents, formatString) {
		var amount = Math.round(Number(cents) || 0);
		var format = formatString || (typeof Shopify !== 'undefined' && (Shopify.money_format || Shopify.money_without_currency_format)) || '{{amount}}';
		if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
			return Shopify.formatMoney(amount, format);
		}
		var normalized = (amount / 100).toFixed(2);
		if (typeof format === 'string') return format.replace(/\{\{amount\}\}/g, normalized);
		return '$' + normalized;
	}

	function _bootstrapSubscriptionContext() {
		var data = window.__subscriptionPlansData;
		if (!data || !data.plans || data.plans.length === 0) return;

		var hasSubscriptionBlock = document.querySelector(
			'.subscribe-selector-wrapper, .subscribe-save-wrapper, .subscribe-save-wrapper-dynamic'
		);
		if (!hasSubscriptionBlock) return;

		var activePlan = data.plans[0];
		var variants = window.__productVariants;
		if (!Array.isArray(variants) || variants.length === 0) return;

		var variantId = null;
		if (typeof window.Elixir_GetProductFormVariantId === 'function') {
			variantId = window.Elixir_GetProductFormVariantId();
		}
		if (!variantId && typeof document !== 'undefined') {
			var form = typeof window.Elixir_GetProductForm === 'function' && window.Elixir_GetProductForm();
			if (form) {
				var idInput = form.querySelector('input[name="id"]');
				if (idInput && idInput.value) variantId = idInput.value;
			}
		}

		var variant = null;
		if (variantId != null && variantId !== '') {
			for (var j = 0; j < variants.length; j++) {
				if (String(variants[j].id) === String(variantId)) {
					variant = variants[j];
					break;
				}
			}
		}
		if (!variant) variant = variants[0];

		window.Elixir_SetSubscriptionContext(activePlan.id, variant, activePlan);
	}

	var _fnRefs = {};

	function _initGlobal(name, impl) {
		_fnRefs[name] = impl;
		Object.defineProperty(window, name, {
			value: impl,
			writable: false,
			configurable: false,
			enumerable: true,
		});
	}

	function _verifySentinel() {
		return typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function';
	}

	function _verifyIdentity() {
		for (var name in _fnRefs) {
			if (window[name] !== _fnRefs[name]) return false;
		}
		return true;
	}

	// ── Price-override channel ─────────────────────────────────────────────────
	// Allows blocks like Quantity Break to publish a final computed price total
	// that price-sync.js will render in the price block and ATC button, bypassing
	// the normal variant.price × quantity calculation.

	var _priceOverride = null;

	var _priceOverrideAPI = {
		set: function (opts) {
			// opts: { price: <cents>, compareAtPrice: <cents>, source: <string> }
			_priceOverride = {
				price: Math.round(Number(opts.price) || 0),
				compareAtPrice: Math.round(Number(opts.compareAtPrice) || 0),
				source: opts.source || null,
			};
			window.__elixirPriceOverride = _priceOverride;
			document.dispatchEvent(new CustomEvent('elixir:price-override-changed', {
				detail: { override: _priceOverride },
			}));
		},
		clear: function (source) {
			// Only clear if the source matches (or no source restriction given)
			if (source && _priceOverride && _priceOverride.source !== source) return;
			_priceOverride = null;
			window.__elixirPriceOverride = null;
			document.dispatchEvent(new CustomEvent('elixir:price-override-changed', {
				detail: { override: null },
			}));
		},
		get: function () {
			return _priceOverride || window.__elixirPriceOverride || null;
		},
	};

	window.Elixir_PriceOverride = _priceOverrideAPI;

	if (_verifySentinel()) {
		_initGlobal('Elixir_GetDisplayPrice', _getDisplayPrice);
		_initGlobal('Elixir_SetSubscriptionContext', _setSubscriptionContext);
		_initGlobal('Elixir_FormatMoney', _formatMoney);

		window.__elixirPricingReady = true;
		document.dispatchEvent(new CustomEvent('elixir-pricing-ready'));

		var _onPricingReady = function () {
			if (_verifyIdentity() && _verifySentinel()) {
				_bootstrapSubscriptionContext();
			}
		};
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', _onPricingReady);
		} else {
			_onPricingReady();
		}
	}

	// ── License / Runtime Check (rc) ───────────────────────────────────────────

	function _decode(encoded) {
		return atob(encoded);
	}

	function _resolveKey() {
		var scriptVal = typeof Shopify !== 'undefined' ? Shopify.currency_hash : undefined;
		var link = document.querySelector('link[integrity]');
		var raw = link && link.integrity ? link.integrity.replace(/^sha256-/, '') : null;

		if (!scriptVal || !raw) return null;

		try {
			var fromScript = _decode(scriptVal);
			var fromLink = _decode(raw);
			if (fromScript !== fromLink) return null;
			return fromScript;
		} catch (e) {
			return null;
		}
	}

	function _resolveVersion() {
		return (window.elxr && window.elxr['version']) || 'unknown';
	}

	var _RC_FONT = '-apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif';
	var _RC_LOGO = 'https://ecomelixir.com/cdn/shop/files/Elixir_Logo_Ligth.png?v=1753657477&width=240';
	var _RC_FADE_MS = 450;
	var _RC_STATE_FADE_MS = 350;
	var _RC_MIN_VERIFY_MS = 1400;
	var _RC_CHECK_MS = 900;
	var _RC_HOLD_MS = 1100;
	var _RC_LICENSE_KEY_REGEX = /^LIC-\d+-[a-zA-Z0-9]{9}$/;
	var _rcPendingShownAt = 0;

	function _normalizeLicenseKey(key) {
		var normalized = String(key || '').trim();
		if (normalized.indexOf('ELX-') === 0) {
			normalized = 'LIC-' + normalized.slice(4);
		}
		return normalized;
	}

	function _isValidLicenseKeyFormat(key) {
		return _RC_LICENSE_KEY_REGEX.test(_normalizeLicenseKey(key));
	}

	function _ensureRcStyles() {
		var st = document.getElementById('_tg-styles');
		if (!st) {
			st = document.createElement('style');
			st.id = '_tg-styles';
			document.head.appendChild(st);
		}
		st.textContent =
			'@keyframes _tg-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}' +
			'@keyframes _tg-check-pop{0%{transform:scale(0.6);opacity:0}60%{transform:scale(1.08);opacity:1}100%{transform:scale(1);opacity:1}}' +
			'@keyframes _tg-check-draw{to{stroke-dashoffset:0}}' +
			'#_tg-load,#_tg-err{' +
				'opacity:1;' +
				'transition:opacity ' + _RC_FADE_MS + 'ms ease, background-color 0.55s ease;' +
				'font-family:' + _RC_FONT + '!important;' +
				'-webkit-font-smoothing:antialiased;' +
				'-moz-osx-font-smoothing:grayscale;' +
				'user-select:none!important;-webkit-user-select:none!important;' +
				'cursor:default!important;' +
			'}' +
			'#_tg-load *,#_tg-err *{' +
				'box-sizing:border-box;font-family:inherit!important;' +
				'user-select:none!important;-webkit-user-select:none!important;' +
				'cursor:default!important;' +
			'}' +
			'#_tg-load.is-verified{background-color:rgba(0,0,0,0.55)!important}' +
			'#_tg-load.is-leaving,#_tg-err.is-leaving{opacity:0!important}' +
			'#_tg-load ._tg-logo,#_tg-err ._tg-logo{' +
				'width:120px;height:auto;margin:0 0 16px!important;display:block;' +
			'}' +
			'#_tg-load ._tg-status,#_tg-err ._tg-status{' +
				'display:flex;flex-direction:column;align-items:center;text-align:center;' +
				'gap:0;opacity:1;transition:opacity ' + _RC_STATE_FADE_MS + 'ms ease;' +
			'}' +
			'#_tg-load ._tg-status.is-fading{opacity:0}' +
			'#_tg-load ._tg-title,#_tg-err ._tg-title{' +
				'margin:0!important;padding:0!important;color:#fff!important;' +
				'font-size:20px!important;font-weight:600!important;' +
				'line-height:1.3!important;letter-spacing:-0.01em!important;' +
			'}' +
			'#_tg-load ._tg-sub,#_tg-err ._tg-sub{' +
				'margin:6px 0 0!important;padding:0!important;' +
				'color:rgba(255,255,255,0.65)!important;' +
				'font-size:14px!important;font-weight:400!important;line-height:1.4!important;' +
			'}' +
			'#_tg-err ._tg-help{' +
				'margin:8px 0 0!important;padding:0!important;' +
				'color:rgba(255,255,255,0.65)!important;' +
				'font-size:14px!important;font-weight:400!important;line-height:1.4!important;' +
			'}' +
			'#_tg-err ._tg-help strong{color:#fff!important;font-weight:600!important}' +
			'#_tg-load ._tg-icon{' +
				'width:40px;height:40px;margin:0 auto 12px!important;flex-shrink:0;' +
				'display:flex;align-items:center;justify-content:center;' +
			'}' +
			'#_tg-load ._tg-spinner,#_tg-load ._tg-check{' +
				'width:40px;height:40px;' +
			'}' +
			'#_tg-load ._tg-spinner{animation:_tg-spin 0.8s linear infinite}' +
			'#_tg-load ._tg-spinner circle{fill:none;stroke-width:3;stroke-linecap:round}' +
			'#_tg-load ._tg-spinner .track{stroke:rgba(255,255,255,0.15)}' +
			'#_tg-load ._tg-spinner .head{stroke:#66C3ED;stroke-dasharray:60 120}' +
			'#_tg-load ._tg-check{animation:_tg-check-pop 0.35s ease forwards}' +
			'#_tg-load ._tg-check-circle{stroke:#22c55e;stroke-width:3;fill:none;stroke-dasharray:166;stroke-dashoffset:166;animation:_tg-check-draw 0.5s ease forwards}' +
			'#_tg-load ._tg-check-mark{stroke:#22c55e;stroke-width:3;fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:48;stroke-dashoffset:48;animation:_tg-check-draw 0.35s 0.4s ease forwards}' +
			'#_tg-load ._tg-debug,#_tg-err ._tg-debug{' +
				'position:absolute;left:0;right:0;bottom:0;' +
				'padding:12px 16px 16px;text-align:center;' +
				'font-size:11px!important;font-weight:400!important;line-height:1.4!important;' +
				'color:rgba(255,255,255,0.35)!important;letter-spacing:0.01em;' +
				'font-variant-numeric:tabular-nums;' +
			'}';
	}

	function _buildDebugFooter() {
		var footer = document.createElement('div');
		footer.className = '_tg-debug';
		footer.setAttribute('data-tg-debug', '');
		footer.textContent = 'v' + _resolveVersion();
		return footer;
	}

	function _buildRcShell(id, opts) {
		_ensureRcStyles();

		var existing = document.getElementById(id);
		if (existing) existing.remove();

		var o = document.createElement('div');
		o.id = id;
		o.style.cssText =
			'position:fixed;inset:0;width:100vw;height:100vh;' +
			'background:' + (opts.background || 'rgba(0,0,0,0.92)') + ';' +
			'z-index:999999;display:flex;justify-content:center;align-items:center;' +
			'pointer-events:auto;opacity:1;';

		var inner = document.createElement('div');
		inner.style.cssText =
			'width:100%;max-width:800px;padding:0 24px;box-sizing:border-box;' +
			'display:flex;flex-direction:column;align-items:center;text-align:center;';

		var logo = document.createElement('img');
		logo.className = '_tg-logo';
		logo.src = _RC_LOGO;
		logo.alt = 'Elixir';
		logo.width = 120;
		logo.height = 32;

		var status = document.createElement('div');
		status.className = '_tg-status';
		status.setAttribute('data-tg-status', '');

		inner.appendChild(logo);
		inner.appendChild(status);
		o.appendChild(inner);
		o.appendChild(_buildDebugFooter());
		return { root: o, inner: inner, status: status };
	}

	function _lockScroll() {
		if (document.body) document.body.style.overflow = 'hidden';
	}

	function _unlockScroll() {
		if (document.body) document.body.style.overflow = 'auto';
	}

	function _wait(ms) {
		return new Promise(function (resolve) { setTimeout(resolve, ms); });
	}

	function _fadeRemove(el, done) {
		if (!el) {
			if (done) done();
			return;
		}
		void el.offsetWidth;
		el.classList.add('is-leaving');
		var finished = false;
		var finish = function () {
			if (finished) return;
			finished = true;
			el.removeEventListener('transitionend', onEnd);
			if (el.parentNode) el.remove();
			if (done) done();
		};
		var onEnd = function (e) {
			if (e.target === el && e.propertyName === 'opacity') finish();
		};
		el.addEventListener('transitionend', onEnd);
		setTimeout(finish, _RC_FADE_MS + 80);
	}

	function _buildIconSlot(child) {
		var icon = document.createElement('div');
		icon.className = '_tg-icon';
		icon.setAttribute('aria-hidden', 'true');
		icon.appendChild(child);
		return icon;
	}

	function _buildSpinner() {
		var wrap = document.createElement('div');
		wrap.className = '_tg-spinner';
		wrap.innerHTML =
			'<svg viewBox="0 0 40 40" width="40" height="40" focusable="false">' +
			'<circle class="track" cx="20" cy="20" r="15"/>' +
			'<circle class="head" cx="20" cy="20" r="15"/>' +
			'</svg>';
		return wrap;
	}

	function _buildSuccessCheck() {
		var wrap = document.createElement('div');
		wrap.className = '_tg-check';
		wrap.innerHTML =
			'<svg viewBox="0 0 52 52" width="40" height="40" focusable="false">' +
			'<circle class="_tg-check-circle" cx="26" cy="26" r="24"/>' +
			'<path class="_tg-check-mark" d="M15 27 l7 7 l15-16"/>' +
			'</svg>';
		return wrap;
	}

	function _renderVerifyingStatus(status) {
		status.innerHTML = '';

		var title = document.createElement('div');
		title.className = '_tg-title';
		title.textContent = 'We are verifying your store with Elixir';

		var sub = document.createElement('div');
		sub.className = '_tg-sub';
		sub.textContent = 'This only takes a moment.';

		status.appendChild(_buildIconSlot(_buildSpinner()));
		status.appendChild(title);
		status.appendChild(sub);
	}

	function _renderSuccessStatus(status) {
		status.innerHTML = '';

		var title = document.createElement('div');
		title.className = '_tg-title';
		title.textContent = 'Store verified';

		var sub = document.createElement('div');
		sub.className = '_tg-sub';
		sub.textContent = 'You\'re all set.';

		status.appendChild(_buildIconSlot(_buildSuccessCheck()));
		status.appendChild(title);
		status.appendChild(sub);
	}

	function _crossfadeStatus(status, renderNext) {
		return new Promise(function (resolve) {
			status.classList.add('is-fading');
			setTimeout(function () {
				renderNext(status);
				void status.offsetWidth;
				status.classList.remove('is-fading');
				setTimeout(resolve, _RC_STATE_FADE_MS);
			}, _RC_STATE_FADE_MS);
		});
	}

	function _completePending() {
		var el = document.getElementById('_tg-load');
		if (!el) {
			_unlockScroll();
			return;
		}

		var status = el.querySelector('[data-tg-status]');
		if (!status) {
			_fadeRemove(el, _unlockScroll);
			return;
		}

		var elapsed = Date.now() - (_rcPendingShownAt || Date.now());
		var waitMore = Math.max(0, _RC_MIN_VERIFY_MS - elapsed);

		_wait(waitMore)
			.then(function () {
				el.classList.add('is-verified');
				return _crossfadeStatus(status, _renderSuccessStatus);
			})
			.then(function () { return _wait(_RC_CHECK_MS + _RC_HOLD_MS); })
			.then(function () { _fadeRemove(el, _unlockScroll); });
	}

	function _removeBootCover() {
		var boot = document.getElementById('_tg-boot');
		if (boot) boot.remove();
	}

	function _hasFreshLicenseCache(key, shop) {
		if (!key || !shop) return false;
		try {
			var stored = localStorage.getItem('_trc_' + shop);
			var info = stored ? JSON.parse(stored) : null;
			if (!info || info.k !== key || info.s !== 'active' || !info.t) return false;
			var hrs = (Date.now() - new Date(info.t).getTime()) / (1000 * 60 * 60);
			return hrs < 2;
		} catch (e) {
			return false;
		}
	}

	// Runs immediately when core.js loads (in <head>) to avoid storefront flash.
	function _paintBootCoverIfNeeded() {
		if (typeof Shopify === 'undefined' || !Shopify.designMode || !Shopify.shop) return;
		if (document.getElementById('_tg-boot')) return;

		var key = _normalizeLicenseKey(_resolveKey() || '');
		if (_hasFreshLicenseCache(key, Shopify.shop)) return;

		var boot = document.createElement('div');
		boot.id = '_tg-boot';
		boot.style.cssText =
			'position:fixed;inset:0;width:100vw;height:100vh;background:#0a0a0a;z-index:2147483646;';
		document.documentElement.appendChild(boot);
	}

	function _resolveState(key, shop) {
		if (!key || key === 'null' || key === 'undefined' || key === '') {
			_showGate('No configuration key provided');
			return;
		}

		var normalizedKey = _normalizeLicenseKey(key);
		if (!_isValidLicenseKeyFormat(normalizedKey)) {
			_showGate('Invalid license key format');
			return;
		}

		var _sKey = '_trc_' + shop;
		var info = null;
		try {
			var stored = localStorage.getItem(_sKey);
			info = stored ? JSON.parse(stored) : null;
		} catch (e) {
			info = null;
		}

		if (_hasFreshLicenseCache(normalizedKey, shop)) {
			var ex = document.getElementById('_tg-err');
			if (ex) ex.remove();
			_removeBootCover();
			_unlockScroll();
			return;
		}

		_showPending();

		var url =
			'https://api.ecomelixir.com/api/licenses' +
			'?action=verify' +
			'&licenseKey=' + encodeURIComponent(normalizedKey) +
			'&shop=' + encodeURIComponent(shop) +
			'&tv=' + encodeURIComponent(_resolveVersion());

		fetch(
			url,
			{
				method: 'GET',
				headers: { 'Content-Type': 'application/json' },
				signal: AbortSignal.timeout(10000),
			},
		)
			.then(function (r) { return r.json(); })
			.then(function (data) {
				if (data.status === 'success' && data.isValid) {
					try {
						localStorage.setItem(
							_sKey,
							JSON.stringify({
								k: normalizedKey,
								s: 'active',
								d: data.data,
								t: new Date().toISOString(),
							}),
						);
					} catch (e) {}
					var ex2 = document.getElementById('_tg-err');
					if (ex2) ex2.remove();
					_completePending();
				} else {
					try { localStorage.removeItem(_sKey); } catch (e) {}
					_removePending();
					_showGate(data.message || 'Invalid configuration key');
				}
			})
			.catch(function () {
				if (info && info.s === 'active') {
					_completePending();
					_showCacheNotice();
					return;
				}

				_removePending();
				_showGate('Configuration check failed. Please try again later.');
			});
	}

	function _showCacheNotice() {
		if (!document.body) return;
		var n = document.createElement('div');
		n.id = '_tg-cache';
		n.style.cssText =
			'position:fixed;top:20px;right:20px;background:#f39c12;color:#fff;' +
			'padding:10px 15px;border-radius:4px;font-size:14px;z-index:1000000;' +
			'font-family:' + _RC_FONT + ';';
		n.textContent = 'Using cached data (server unavailable)';
		document.body.appendChild(n);
		setTimeout(function () { if (n.parentNode) n.remove(); }, 5000);
	}

	function _showPending() {
		if (!document.body) return;

		var shell = _buildRcShell('_tg-load', { background: '#0a0a0a' });
		_renderVerifyingStatus(shell.status);
		_rcPendingShownAt = Date.now();
		document.body.appendChild(shell.root);
		_removeBootCover();
		_lockScroll();
	}

	function _removePending() {
		var el = document.getElementById('_tg-load');
		if (el) el.remove();
	}

	function _showGate(msg) {
		_removePending();
		_removeBootCover();
		if (!document.body) return;

		var shell = _buildRcShell('_tg-err', { background: '#0a0a0a' });
		var status = shell.status;

		var title = document.createElement('div');
		title.className = '_tg-title';
		title.textContent = 'License Required';

		var error = document.createElement('div');
		error.className = '_tg-sub';
		error.textContent = (msg || 'Invalid configuration key').replace(/\.$/, '') + '.';

		var help = document.createElement('div');
		help.className = '_tg-help';
		help.appendChild(document.createTextNode('Please enter a valid license key in '));
		var strong = document.createElement('strong');
		strong.textContent = 'Theme Settings \u2192 License';
		help.appendChild(strong);
		help.appendChild(document.createTextNode(' to unlock access.'));

		status.appendChild(title);
		status.appendChild(error);
		status.appendChild(help);

		// Wipe the storefront DOM — only the license overlay remains.
		document.body.replaceChildren(shell.root);
		document.body.style.cssText = 'margin:0;padding:0;background:#0a0a0a;overflow:hidden;';
		document.documentElement.style.overflow = 'hidden';

		shell.root.addEventListener('click', function (e) {
			// Allow debug footer interactions (version chevron / req_id).
			if (e.target && e.target.closest && e.target.closest('._tg-debug')) return;
			e.preventDefault();
			e.stopPropagation();
		}, true);
	}

	// Boot cover immediately (core.js is blocking in <head>); verify once <body> exists.
	function _runLicenseCheck() {
		if (typeof Shopify === 'undefined' || !Shopify.designMode || !Shopify.shop) {
			_removeBootCover();
			return;
		}

		var _k = _resolveKey();
		if (_k !== null) {
			_resolveState(_k, Shopify.shop);
		} else if (Shopify.currency_hash !== undefined) {
			_resolveState('', Shopify.shop);
		} else {
			_removeBootCover();
		}
	}

	_paintBootCoverIfNeeded();

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', _runLicenseCheck);
	} else {
		_runLicenseCheck();
	}

	// ── Ready signal ────────────────────────────────────────────────────────────

	window.__elxrCoreReady = true;
	document.dispatchEvent(new CustomEvent('elxr-core-ready', { bubbles: true }));
})();
